import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Form, Input, Row, Table } from "antd";

import productApi from "../../../../apis/Product.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const productColumns = [
  {
    title: "상품번호",
    // width: 65,
    dataIndex: "product_id",
    key: "product_id",
    ellipsis: true,
    // fixed: 'left',
    sorter: (a, b) => {},
  },
  {
    title: "카테고리",
    // width: 80,
    dataIndex: "product_category_name",
    key: "product_category_name",
    ellipsis: true,
    render: (value) => {
      if (value === "") {
        return <span>-</span>;
      } else {
        return value;
      }
    },
  },
  {
    title: "브랜드명",
    // width: 130,
    dataIndex: "product_brand_name",
    key: "product_brand_name",
    ellipsis: true,
  },
  {
    title: "상품명",
    // width: 150,
    dataIndex: "product_name",
    key: "product_name",
    ellipsis: true,
  },
];
const ProductSearch = ({
  searchOptions,
  handleChange,
  handleProductSearch,
  handleProductRowEvent,
  tableOnChange,
  orderType,
  orderBy,
  orderInfo,
  setOrderInfo,
  selectedProductRows,
  setSelectedProductRows,
  selectedProductRowKeys,
  setSelectedProductRowKeys,
}) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [error, setError] = useState("");

  const [productList, setProductList] = useState([]);

  const productRowSelection = {
    type: "radio",
    selectedRowKeys: selectedProductRowKeys,
    onSelect: (record, selected) => {
      // 옵션 선택값 초기화
      // setSelectedOptionRowKeys([])
      // setSelectedOptionRows([])
      if (selected) {
        setSelectedProductRowKeys([record.product_id]);
        setSelectedProductRows([record]);
      } else {
        setSelectedProductRowKeys([]);
        setSelectedProductRows([]);
        setOrderInfo({
          total_price: 0,
          ...orderInfo,
        });
      }
    },
  };
  useEffect(() => {
    if (user?.id) {
      readProductList();
    }
  }, [user, orderType, orderBy, searchOptions]);
  /**
   * 상품 검색 api 호출
   */
  const readProductList = useCallback(
    async (type = "", productName) => {
      // setIsLoading(true);
      try {
        let res;
        if (type === "custom") {
          res = await productApi.readProductListAll(
            0,
            "",
            productName,
            searchOptions.product_brand_name,
            orderType,
            orderBy,
            user.id === 724 ? 1 : user.id,
          );
        } else {
          res = await productApi.readProductListAll(
            0,
            "",
            searchOptions.product_name,
            searchOptions.product_brand_name,
            orderType,
            orderBy,
            user.id === 724 ? 1 : user.id,
          );
        }
        if (res.code === 200) {
          setProductList(res.result);
        } else {
          alert("상품 검색에 실패하였습니다. 다시 시도해주시길 바랍니다.");
        }
        // setIsLoading(false)
      } catch (error) {
        // setIsLoading(false)
        setError(error);
        console.log("readProduct search error", error);
        alert(error);
      }
    },
    [user, orderType, orderBy, searchOptions],
  );

  return (
    <div className={`order-component-each-detail`}>
      <h4 className={`order-each-detail-title`}>상품 검색</h4>
      <Row
        style={{
          width: "100%",
          justifyContent: "space-between",
          rowGap: "8px",
        }}
      >
        <Form.Item className="center-label" labelAlign="left">
          <Input.Search
            name="product_name"
            value={searchOptions.product_name}
            onChange={handleChange}
            placeholder={`상품명`}
            onSearch={handleProductSearch}
          />
        </Form.Item>
        <Form.Item className="center-label" labelAlign="left">
          <Input.Search
            name="product_brand_name"
            value={searchOptions.product_brand_name}
            onChange={handleChange}
            placeholder={`브랜드명`}
            onSearch={handleProductSearch}
          />
        </Form.Item>
      </Row>

      <Table
        className="order-create-product-list-table"
        rowSelection={productRowSelection}
        columns={productColumns}
        dataSource={productList}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="product_id"
        rowClassName="coupon-table-row"
        scroll={{ y: "calc(191px - 48px)" }}
        onRow={handleProductRowEvent}
        onChange={tableOnChange}
        tableLayout="auto"
        pagination={false}
      />
    </div>
  );
};
export default ProductSearch;
